// config.js 用来存储一些常用的变量/常量
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '3e5f6157-92e1-4c2b-9bee-3e862e1a0c2d';
export const MODAL_CLOSE_SEC = 2.5;
